/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BbsCategoryInfoRespVo
 */
export interface BbsCategoryInfoRespVo {
    /**
     * 分类编号
     * @type {number}
     * @memberof BbsCategoryInfoRespVo
     */
    id?: number;
    /**
     * 分类级别：目前只有 1 级和 2 级分类
     * @type {number}
     * @memberof BbsCategoryInfoRespVo
     */
    level?: number;
    /**
     * 是否可用：0-不可用，1-可用
     * @type {number}
     * @memberof BbsCategoryInfoRespVo
     */
    enable?: number;
    /**
     * 父级分类编号
     * @type {number}
     * @memberof BbsCategoryInfoRespVo
     */
    parentId?: number;
    /**
     * 分类名称
     * @type {string}
     * @memberof BbsCategoryInfoRespVo
     */
    nameCn?: string;
    /**
     * 分类名称
     * @type {string}
     * @memberof BbsCategoryInfoRespVo
     */
    nameKr?: string;
    /**
     * 是否只有登录后可见  0 不是 1 是
     * @type {number}
     * @memberof BbsCategoryInfoRespVo
     */
    onlyLoginIn?: number;
    /**
     * 排序
     * @type {number}
     * @memberof BbsCategoryInfoRespVo
     */
    sort?: number;
}

/**
 * Check if a given object implements the BbsCategoryInfoRespVo interface.
 */
export function instanceOfBbsCategoryInfoRespVo(value: object): value is BbsCategoryInfoRespVo {
    return true;
}

export function BbsCategoryInfoRespVoFromJSON(json: any): BbsCategoryInfoRespVo {
    return BbsCategoryInfoRespVoFromJSONTyped(json, false);
}

export function BbsCategoryInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BbsCategoryInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'level': json['level'] == null ? undefined : json['level'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'nameCn': json['nameCn'] == null ? undefined : json['nameCn'],
        'nameKr': json['nameKr'] == null ? undefined : json['nameKr'],
        'onlyLoginIn': json['onlyLoginIn'] == null ? undefined : json['onlyLoginIn'],
        'sort': json['sort'] == null ? undefined : json['sort'],
    };
}

export function BbsCategoryInfoRespVoToJSON(json: any): BbsCategoryInfoRespVo {
    return BbsCategoryInfoRespVoToJSONTyped(json, false);
}

export function BbsCategoryInfoRespVoToJSONTyped(value?: BbsCategoryInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'level': value['level'],
        'enable': value['enable'],
        'parentId': value['parentId'],
        'nameCn': value['nameCn'],
        'nameKr': value['nameKr'],
        'onlyLoginIn': value['onlyLoginIn'],
        'sort': value['sort'],
    };
}

